<script>
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import { get } from 'lodash';

export default {
  mixins: [fandomBasicMixin],
  methods: {
    getTarget: Fandom.getTarget,
    getLangLink(lang) {
      const slug = globalState.pageModel.name_to_content[globalState.pageModel.main_content_name].slug;
      return Fandom.urljoin("/", lang, slug);
    },
    showLangSwitch() {
      const parents = get(globalState.pageModel, ["name_to_content", globalState.pageModel.main_content_name, "parent_names"], []);
      return (parents.indexOf("en") > -1) && (parents.indexOf("it") > -1); 
    }
  },
  computed: {
    disclaimer() {
      return this.pageModel.name_to_content[this.pageModel.main_content_name].disclaimer || this.content.disclaimer;
    }
  }
};
</script>

<template>
  <div 
    v-if="isContentVisibleToUser()"  
    class="row mx-0 justify-content-center"
    landing-footer-component
  >
    <div v-if="content.social_icons" class="col-12 py-md-3 bg-gray-200">
      <div class="row py-3 py-md-4 justify-content-center">
        <div class="col-12 col-md-10">
          <div class="text-uppercase text-center small font-weight-bold pb-3 pb-md-5">{{ft('globals.follow_us')}}</div>
          <div class="d-flex mx-n3 mx-md-n5 justify-content-center">
            <div v-for="icon in content.social_icons" class="mx-3 mx-md-5">
              <a :href="icon.url.url" class="social-icon" :target="getTarget(icon.url)">
                <i :class="`fab fa-${icon.icon}`"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="content.landing_button && content.landing_button_label" class="col-12 bg-gray-800 py-md-5">
      <div class="row p-5 justify-content-center align-items-center">
        <div class="col-12 col-md-10 d-flex flex-column align-items-center justtify-content-center">
          <div v-if="content.landing_button_label" class="h1 text-white font-weight-normal pb-2 text-center">{{ content.landing_button_label }}</div>
          <div class="w-100 d-flex justify-content-center">
            <a v-if="content.landing_button" :href="content.landing_button.url" :target="getTarget(content.landing_button)" class="btn btn-outline-light">
              {{content.landing_button.title}}
            </a> 
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 bg-dark py-3 py-md-0 text-uppercase">
      <div class="row py-2 py-md-4 justify-content-center">
        <div class="col-12 col-lg-10">
          <div class="row flex-md-row-reverse d-flex justify-content-between">
            <div class="col-12 col-lg-4 mx-n2 pb-3 pb-lg-0 d-flex justify-content-lg-end align-items-center" v-if="showLangSwitch()">
              <a
                class="mx-2 navbar-link disclaimer"
                :href="getLangLink('en')"
                :class="{'selected': globalState.lang == 'en'}"
                :disabled="globalState.lang == 'en'"
              >{{ft("globals.en")}}</a>
              <span class="text-gray-200">|</span>
              <a
                class="mx-2 navbar-link disclaimer"
                :href="getLangLink('it')"
                :class="{'selected': globalState.lang == 'it'}"
                :disabled="globalState.lang == 'it'"
              >{{ft("globals.it")}}</a>
            </div>
            <div v-if="!!content.navbar.length" class="col-12 col-lg-4 pb-3 pb-lg-0 mx-n2 d-flex justify-content-lg-center">
              <span v-for="(item, index) in content.navbar">
                <span v-if="index !== 0" class="text-gray-200">|</span>
                <a class="navbar-link mx-2 disclaimer" :href="item.url.url">{{item.url.title}}</a>
              </span>
            </div>
            <div v-if="disclaimer" class="disclaimer col-12 col-lg-4 mx-n2 d-flex align-items-center">
              <div class="mx-2">{{disclaimer}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[landing-footer-component] {
  background-color: $gray-900;

  a[data-toggle="collapse"] {

    & > i {
      transition: transform .25s;
    }

    &.collapsed > i {
      transform: rotate(180deg);
    }
  }

  .btn {
    width: fit-content;
  }

  #supported-by {
    font-size: .75rem;
    font-weight: 800;
  }

  .social-icon {
    font-size: 1.5rem;
    color: $gray-900;
    transition: color .25s;

    &:hover,
    &:active,
    &:focus {
      color: $gray-500;
    }
  }

  .logo {
    max-width: 6rem;
  }

  .navbar-link {
    font-weight: 300;
    color: $white;
    transition: color $animation-time-fast;

    &:hover {
      color: darken($white, 15%);
    }
  }

  .navbar-link,
  .section-title {
    font-size: .875rem;
  }

  .section-title {
    font-weight: 800;
  }

  .disclaimer {
    font-size: 0.75rem;
    color: $gray-200;
  }

  .box-bg {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }

  .selected {
    font-weight: bold;
    color: $white;
  }

  .bg-gray-200 {
    background-color: $gray-200;
  }
  
  @include media-breakpoint-down(sm) {
    .logo {
      background-size: 80% !important;

      &.background-left {
        background-position: left;
      }

      &.background-right {
        background-position: right;
      }
    }
  }

}

</style>